const state = {
    routerList: []
}

const getters = {
    routerList: (state) => {
        return state.routerList
    },
}

const actions = {
    router_setList({
        commit
    }, params) {
        commit('setRouterList', params)
    }

}
const mutations = {
    setRouterList(state, params) {
        state.routerList = [...params]
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}